import heroImage from "@/assets/hero-home.webp";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById("contatti")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      {/* overlay: gradiente da sinistra (dove c'è il testo) verso destra, che arriva
          a 0 così i colori più vividi dell'immagine restano puliti */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/20 to-transparent" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-2xl text-white [text-shadow:0_2px_10px_rgba(0,0,0,0.75)]">
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-[#f0d9a8] animate-fade-in">
            Studio Olistico · Colli Euganei
          </p>

          <h1 className="mt-4 font-serif font-light leading-[0.95] text-6xl md:text-8xl animate-fade-up">
            ORIGINI
          </h1>
          <p className="mt-2 font-serif italic text-2xl md:text-4xl text-[#f0d9a8] animate-fade-up">
            tra radici ed ali
          </p>

          <p className="mt-6 text-lg md:text-xl font-light text-white/90 max-w-md lg:max-w-xl animate-fade-up">
            Ayurveda, riflessologia plantare e trattamenti olistici per il
            riequilibrio di mente, corpo e spirito. Un percorso naturale e
            personalizzato, con Laura.
          </p>

          <div className="mt-9 flex flex-wrap gap-4 animate-fade-up">
            <Button
              size="lg"
              onClick={scrollToContact}
              className="text-base px-8 py-6 rounded-full bg-accent hover:bg-accent/90 text-accent-foreground shadow-lg"
            >
              Prenota una consulenza
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="text-base px-8 py-6 rounded-full bg-white/10 border-white/70 text-white hover:bg-white hover:text-primary backdrop-blur-sm"
            >
              <Link to="/trattamenti">Scopri i trattamenti</Link>
            </Button>
          </div>
        </div>
      </div>

      {/* indicatore scroll */}
      <button
        onClick={() => document.getElementById("studio")?.scrollIntoView({ behavior: "smooth" })}
        aria-label="Scorri"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/80 hover:text-white transition-colors"
      >
        <ChevronDown className="w-8 h-8 animate-bounce" />
      </button>
    </section>
  );
};

export default Hero;
